
webpack.register(
    'components/video-landing/live-player/live-player',
    function() {
        return require('components/video-landing/live-player/live-player');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/video-landing/live-player/live-player'/>\r\n\r\n<live-player {live-video-card}=\"liveVideo\" {ended}=\"@closeLiveVideoPlayer\" {youbora}=\"true\" {title}=\"title\" can-inserted=\"@playerInserted\"></live-player>");